import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createBlock(_component_swiper, {
    key: $setup.sliderKey,
    modules: $setup.modules,
    autoHeight: true,
    spaceBetween: 12,
    speed: 500,
    slidesPerView: 1,
    pagination: { clickable: true, el: '.js-information-slider-pagination' },
    navigation: { nextEl: '.js-information-slider-next', prevEl: '.js-information-slider-prev' },
    autoplay: { delay: 5000 },
    onSwiper: $setup.onSwiper
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["pagination", "navigation"]))
}